<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'PhoneLabel',

    functional: true,

    props: {
        phone: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        const isEmpty = !props.phone || props.phone.length === 0;

        data.props = {
            item: isEmpty ? null : props.phone,
            iconClass: 'fa fa-fw fa-phone',
            none: parent.$t('common.labels.phone.nil'),
        };

        return createElement(DataLabel, data);
    },
};
</script>
